export const SET_DICTIONARY = 'DICTIONARY';
export const GET_LIST_LANGUAGE = 'GET_LIST_LANGUAGE';
export const SET_LIST_LANGUAGE = 'SET_LIST_LANGUAGE';
export const GET_CURRENT_LANGUAGE = 'GET_CURRENT_LANGUAGE';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const ADJUST_FONT_SIZE = 'ADJUST_FONT_SIZE';
